import { Formik } from 'formik'
import * as React from 'react'
import { CancelAppointmentForm } from './CancelAppointmentForm'
import { useActions } from './hooks'
import { ICancelAppointmentProps } from './typings'

export const CancelAppointmentWrapper: React.FC<ICancelAppointmentProps> = (
  props: ICancelAppointmentProps,
) => {
  const { onSubmit } = useActions(props)

  return (
    <Formik
      initialValues={{
        notServicedReason: '',
      }}
      onSubmit={onSubmit}
    >
      <CancelAppointmentForm {...props} />
    </Formik>
  )
}
CancelAppointmentWrapper.displayName = 'CancelAppointmentWrapper'
